import React from "react";

function MoneyMarketFundFeatures() {
  return (
    <div>
      The Britam money market fund is your ideal investment option for cash you
      intend to use to meet your short term goals. These may include:
      <br />
      -Emergency Fund
      <br />
      -School Fees
      <br />
      -Deposit - Car/Mortgage /Land
      <br />
      -Chama/Investment Funds
      <br />
      -Family and Staff welfare funds - for weddings and burials etc.
      <br />
      -Wedding planning
      <br />
      -Construction/Project funds
      <br />
      -Holiday Planning, etc.
    </div>
  );
}

export default MoneyMarketFundFeatures;
